import React from "react";
import ReactDOM from "react-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msalInstance";
import App from "./App";
import "./index.css";

async function initializeApp() {
  try {
    // Step 1: Initialize MSAL
    await msalInstance.initialize();

    // Step 2: Handle redirect from Azure AD (critical for Edge!)
    const response = await msalInstance.handleRedirectPromise();

    if (response) {
      // User just completed login via redirect
      console.log("Authentication successful after redirect");
    } else {
      // Check for existing accounts
      const accounts = msalInstance.getAllAccounts();

      if (accounts.length > 0) {
        // We have accounts - validate tokens aren't stale
        try {
          await msalInstance.acquireTokenSilent({
            account: accounts[0],
            scopes: process.env.REACT_APP_AZURE_SCOPES?.split(/\s+/) || [],
            forceRefresh: false,
          });

          console.log("Existing session is valid");
        } catch (error) {
          // Tokens are stale/invalid - clear everything
          console.warn("Stale tokens detected, clearing cache:", error);

          await msalInstance.clearCache();
          localStorage.removeItem("accessToken");
          localStorage.removeItem("MSGraphToken");
          localStorage.removeItem("userGroups");
        }
      }
    }
  } catch (error) {
    console.error("MSAL initialization error:", error);
  }

  ReactDOM.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

initializeApp();
